export default {
    accept: 'Accept'
}